export const CAMERA_SERVER_TYPE = {
  ANTMEDIA: 1,
  MEDIAMTX: 2
};
